export interface ContextVisibilityState {
    showAll: boolean;
    overrides: Record<string, boolean>;
}
export const contextIsVisible = (state: ContextVisibilityState, key: string) =>
    state.overrides[key] ?? state.showAll;

/** Mixed state always resolves to hidden before the next click shows all. */
export function toggleAllContext(
    state: ContextVisibilityState,
    keys?: string[]
): ContextVisibilityState {
    return {
        showAll: !(keys?.length
            ? keys.some((key) => contextIsVisible(state, key))
            : state.showAll || Object.values(state.overrides).some(Boolean)),
        overrides: {}
    };
}
export function toggleQuestionContext(
    state: ContextVisibilityState,
    key: string
): ContextVisibilityState {
    return { ...state, overrides: { ...state.overrides, [key]: !contextIsVisible(state, key) } };
}
